<template>
    <div>
        <b-tabs
            class="paper-overview-tab apprentice-tab"
            id="paper-show-main-tab"
            v-model="activeTab"
            content-class="paper-overview-content"
            @input="updateTabIndex"
            :key="'paper-show-main-tab'">
            <template #tabs-end>
                <design-2021-paper-show-tab-buttons-component
                    :group-in="groupIn"
                    :project-in="projectIn"
                    :title-in="projectIn.title"
                    :can-edit-title="canEditTitle">
                </design-2021-paper-show-tab-buttons-component>
            </template>

            <b-tab
                :title="$t('paper.progress')"
                title-item-class="progress-tab">
                <design-2021-paper-show-progress-component
                    :project-in="projectIn"
                    :roadmap-in="roadmapIn"
                    :project-id="projectId"
                    :group-in="groupIn"
                    :editorfile-in="editorfileIn"
                    :action-plan-editor-file-in="actionPlanEditorFileIn"
                    :presentationeditorfile-in="presentationeditorfileIn"
                    :versions-in="versionsIn"
                    :agenda-items="agendaItems"
                    :messages-in="messagesIn"
                    :profile-image-in="profileImageIn"
                    @showCalendar="showCalendar"
                    @showMessages="activeTab = 2"
                    :action-plan-versions-in="actionPlanVersionsIn"
                    :power-point-versions-in="powerPointVersionsIn">
                </design-2021-paper-show-progress-component>
            </b-tab>

            <b-tab
                title="Tools"
                title-item-class="tools-tab">
                <design-2021-paper-show-tools-component
                    ref="show-tools-component"
                    :project-in="projectIn"
                    :group-in="groupIn"
                    :logs-in="logsIn"
                    :logs-by-time-in="logsByTimeIn"
                    :questionnaire="questionnaire"
                    :ratings="ratings"
                    :plagiarism-reports-in="plagiarismReportsIn"
                    :agenda-items="agendaItems"
                    :agenda-title="agendaTitle"
                    :project-id="projectId"
                    :is-student="isStudent"
                    :is-teacher="isTeacher"
                    :user-id="userId"
                    :force-active-tab="forceActiveTab">
                </design-2021-paper-show-tools-component>
            </b-tab>

            <b-tab
                id="tab-messages"
                v-if="groupIn.messages"
                :title="$t('paper.messages')"
                title-item-class="messages-tab">
                <template v-slot:title>
                    {{ $t('paper.messages') }}
                    <span
                        class="notification-bubble paper-messages-count messages-count-bubble"
                        v-if="count !== 0">
                        {{ count }}
                    </span>
                </template>
                <design-2021-project-show-message-component
                    :project-type-id="projectId"
                    :messages-in="messagesIn"
                    message-type="project"
                    :is-student="isStudent"
                    :profile-image-in="profileImageIn">
                </design-2021-project-show-message-component>
            </b-tab>

            <b-tab
                v-if="
                    $authUser.isTeacher() &&
                    (projectIn.type_id === 1 || projectIn.type_id === 2 || projectIn.type_id === 4)
                "
                :title="$t('common.manage')"
                :id="$t('paper.tab_manage')"
                :title-item-class="$t('paper.manage_tab')">
                <div>
                    <design-2021-paper-show-teacher-component
                        :project-in="projectIn"></design-2021-paper-show-teacher-component>
                </div>
            </b-tab>

            <b-tab
                id="tab-admin"
                v-if="
                    $authUser.isAdmin() &&
                    (projectIn.type_id === 1 || projectIn.type_id === 2 || projectIn.type_id === 4)
                "
                title="Admin"
                title-item-class="admin-tab">
                <div>
                    <design-2021-paper-show-admin-component
                        :project-in="projectIn"></design-2021-paper-show-admin-component>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { CommonBus } from '../../../app';
import Design2021PaperShowTabButtonsComponent from './design-2021-paper-show-tab-buttons-component.vue';
import Design2021PaperShowProgressComponent from '../../roadmap/show/tabs/design-2021-paper-show-progress-component.vue';
import Design2021PaperShowToolsComponent from './tabs/design-2021-paper-show-tools-component.vue';
import Design2021ProjectShowMessageComponent from '../../project/show/design-2021-project-show-message-component.vue';
import Design2021PaperShowTeacherComponent from './tabs/design-2021-paper-show-teacher-component.vue';
import Design2021PaperShowAdminComponent from './tabs/design-2021-paper-show-admin-component.vue';

export default {
    name: 'design-2021-paper-show-component',
    components: {
        Design2021PaperShowAdminComponent,
        Design2021PaperShowTeacherComponent,
        Design2021ProjectShowMessageComponent,
        Design2021PaperShowToolsComponent,
        Design2021PaperShowProgressComponent,
        Design2021PaperShowTabButtonsComponent,
    },
    props: [
        'messagesIn',
        'projectId',
        'groupIn',
        'roadmapIn',
        'projectIn',
        'editorfileIn',
        'actionPlanEditorFileIn',
        'presentationeditorfileIn',
        'versionsIn',
        'actionPlanVersionsIn',
        'powerPointVersionsIn',
        'logsIn',
        'logsByTimeIn',
        'plagiarismReportsIn',
        'questionnaire',
        'ratings',
        'agendaItems',
        'agendaTitle',
        'isTeacher',
        'isStudent',
        'userId',
        'canEditTitle',
        'profileImageIn',
    ],
    data() {
        return {
            activeTab: 0,
            forceActiveTab: null,
            count: this.projectIn.group.messages_count,
            messagesActive: false,
        };
    },

    methods: {
        resetUnreadMessages() {
            this.axios.delete(this.routes.paperDeleteUnreadMessages(this.projectIn.id)).then(
                (response) => {
                    this.count = 0;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateTabIndex(tabIndex) {
            if (tabIndex === 2) {
                this.resetUnreadMessages();
            }

            if (tabIndex === 0) {
                CommonBus.$emit('initiate-slider');
            }

            localStorage.setItem('paperMainTab', tabIndex);
        },

        showCalendar() {
            this.activeTab = 1;
            this.forceActiveTab = 0;
            this.$refs['show-tools-component'].updateTabIndex(0);
        },
    },

    created() {
        let params = new URL(document.location).searchParams;
        let message = params.get('message');

        this.messagesActive = !!message;

        this.count = this.count + this.projectIn.messages_count;

        if (localStorage.getItem('paperMainTab')) {
            this.activeTab = parseInt(localStorage.getItem('paperMainTab'));

            if (parseInt(localStorage.getItem('paperMainTab')) === 2) {
                this.resetUnreadMessages();
            }
        }
    },
};
</script>

<style scoped lang="scss">
::v-deep .paper-overview-tab {
    .progress-tab {
        min-width: 95px;
    }

    .tools-tab {
        min-width: 71px;
    }

    .messages-tab {
        min-width: 108px;
    }

    .admin-tab {
        min-width: 83px;
    }
}
</style>
